import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ReactQueryProvider } from 'lib/react-query/provider';
import { StateProvider } from 'state/provider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ReactQueryProvider>
      <StateProvider>
        <App />
      </StateProvider>
    </ReactQueryProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
